import * as React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { useTranslation } from 'react-i18next';
import {
  FavoritesScreen,
  PersonalizationScreen,
  ProfileScreen,
  SettingsScreen,
} from '../../screens';
import { isMobile } from '../../utils/responsive';
import { StackHeader } from '../../components';
import { ScreenName } from '../types';

const ProfileStack = createStackNavigator();

export default function ProfileStackNavigator() {
  const { t } = useTranslation();
  return (
    <ProfileStack.Navigator
      screenOptions={{
        gestureEnabled: true,
        headerShown: false,
      }}
    >
      <ProfileStack.Screen
        name={ScreenName.ProfileScreen}
        component={ProfileScreen}
        options={({ navigation }) => {
          return {
            gestureEnabled: true,
            headerShown: isMobile,
            header: () => {
              return <StackHeader navigation={navigation} headerTitle={t('navigation:profile')} />;
            },
            title: t('navigation:profile'),
          };
        }}
      />

      <ProfileStack.Screen
        name={ScreenName.SettingsScreen}
        component={SettingsScreen}
        options={({ navigation }) => {
          return {
            gestureEnabled: true,
            headerShown: isMobile,
            header: () => {
              return <StackHeader navigation={navigation} headerTitle={t('section:settings')} />;
            },
            title: t('section:settings'),
          };
        }}
      />

      <ProfileStack.Screen
        name={ScreenName.PersonalizationScreen}
        component={PersonalizationScreen}
        options={({ navigation }) => {
          return {
            gestureEnabled: true,
            headerShown: isMobile,
            header: () => {
              return (
                <StackHeader navigation={navigation} headerTitle={t('section:customization')} />
              );
            },
            title: t('section:customization'),
          };
        }}
      />

      <ProfileStack.Screen
        name={ScreenName.FavoritesScreen}
        component={FavoritesScreen}
        options={({ navigation }) => {
          return {
            gestureEnabled: true,
            headerShown: isMobile,
            header: () => {
              return (
                <StackHeader navigation={navigation} headerTitle={t('navigation:favorites')} />
              );
            },
            title: t('navigation:favorites'),
          };
        }}
      />
    </ProfileStack.Navigator>
  );
}
